import { createSelector } from 'reselect'

const getStore = state => state.store

const storeSearchFormSelector = createSelector(
	[ getStore ],
	storeData => ({
		page: storeData.page,
		folderUID: storeData.folderUID,
	})
)

export default storeSearchFormSelector
